//TODO: generalize this so its reusable across app
import React, {Component} from 'react'
import Autosuggest from 'react-autosuggest';

// probably don't actually care about the value and just want to use the text value they entered if 
// they hit enter
const getSuggestionValue = suggestion => suggestion.name;

// Use your imagination to render suggestions.


 export default class GlobalSearchAutoSuggest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value:"",
      suggestions: [], 
      loading: false ,
      fetching_value: "",
      sublistId: null
    };

    this.onChange = this.onChange.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.fetchSearch = this.fetchSearch.bind(this);
    this.shouldRenderSuggestions = this.shouldRenderSuggestions.bind(this);
    this.getSectionSuggestions = this.getSectionSuggestions.bind(this);
    this.renderSectionTitle = this.renderSectionTitle.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.onSuggestionHighlighted = this.onSuggestionHighlighted.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
  };
   
  renderSuggestion(suggestion){
  
  let t = this; 
  if (suggestion.noresults){
    return (
      <small className='no-result-suggestion-react'>No results</small>
      )

  }
  
  const renderProduct = function(suggestion){
    let path = "/products/details/" + suggestion.slug; 

    return (
   
        <a href={path}>{suggestion.name}</a>
      

      );
  }

   const renderCollection = function(suggestion){
    let path = "/collections/" + suggestion.cached_slug; 

    let names = suggestion.collection_path.map(function(d, i){
      let spacer = suggestion.collection_path[i + 1] == undefined ? "" : " > ";
       return (
        
          <small key={i}r> {d}{spacer} </small>
              
    
        );
    })


    return ( 
      <div className='category-list-item'>
        <a href={path}>{names}</a>
      </div>

      );
  }

  const renderBrands = function(collection){
    if (collection.brands && collection.brands.length > 0){
       let slug = collection.cached_slug; 
       let brandListClass= "brand-subList"
       let brands =  collection.brands.map(function(m, index){
          return (
            <li key={index}> 
            {renderBrand(m, slug)}
            </li> 
            )      
          })
       return (
        <span>
        <span className='caret right'> </span>
        <ul className= {brandListClass}>
            {brands}
        </ul>
        </span>
        );
    }

  }

  const renderBrand = function(brand, collection_slug){
    let path = "/collections/" + collection_slug + "?brand=" + brand.name;
    path = encodeURI(path);
    return (
        <small><a href={path}>{brand.name}</a></small>
      )

  }



  const renderMatch = function(suggestion){
     //let path = "/products/details/" + suggestion.slug;
     
     if (suggestion.products_id){
      return renderProduct(suggestion); 
     }

     else {
      return renderCollection(suggestion);
     }

  }

  return (

    <span>
     {renderMatch(suggestion)}
     </span>

  
   
  
);
}
 onChange(value, args){
     
    let newValue = args.newValue;
    this.setState({
      value: newValue
    });


  }




  onSuggestionHighlighted({ suggestion }){
    
   if (suggestion){
     this.setState({value: this.state.fetching_value});
    }

  }

  onSuggestionSelected(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }){
   
    //suggestion is a category
   
    if (event.target.nodeName != 'A'){
      event.preventDefault();
     }
    if (suggestion.cached_slug){
      window.location = '/collections/' + suggestion.cached_slug;

    }
    else {
      window.location = '/products/details/' + suggestion.slug; 
    }
  }


   fetchSearch(value){
     var t = this;


     var url = Routes.auto_suggest_search_path({q: value});

     if (value !== t.state.fetching_value) {

       t.setState({loading: true, fetching_value: value});

       $.ajax({
         method: 'GET',
         url: url,
         dataType: 'JSON',
         success: function(data, statusText, xhr){ 

           let  products_and_collections = [{title: 'Categories', items: data.collections}, {title: 'Products', items: data.products}];

           if(t.state.value !== t.state.fetching_value){
             t.setState({suggestions: products_and_collections});
             t.fetchSearch(t.state.value);
           }
           else{
             t.setState({loading: false, suggestions: products_and_collections});
           }
         },
         error: function(data, statusText, xhr){
           t.setState({loading: false})

         }
       });

     }
   }
   
  shouldRenderSuggestions(value = ""){

   let outcome =  (value.trim().length > 1);
   return outcome;

 
  }

  getSectionSuggestions(section){
    if (section && section.items && section.items.length > 0){
      return section.items; 

     }

     else {
      return [{name: 'No Results', noresults: true}];

     }

  }

  renderSectionTitle(section){

    return (
      <strong >{section.title}</strong> 
      )
  }

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested(args){
    let value = args.value; 
    if (!this.state.loading){
      this.fetchSearch(value);
    }
  } 

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested(){
    // this.setState({
    //   suggestions: [] 
    // });
  }


  renderSuggestionsContainer({containerProps, children, query}){
    
    let td_sections = [];
    if (children){
     td_sections = children.map(function(suggestions, i){
   
      return (
        <td key={i}  className='sectionBox'>{suggestions}</td>
        );
    })
  }


    return (
      <table  {...containerProps}> 
       <tbody>
       <tr> 
          {td_sections}
        
       </tr>
      </tbody>
      </table> 

      )

  }

  render() {
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: 'Search...',
      value,
      onChange: this.onChange, 
      name: 'q', 
      className: 'form-control'

    };

    return (
    
      <Autosuggest
    
        suggestions={suggestions}
        getSectionSuggestions={this.getSectionSuggestions}
        renderSectionTitle={this.renderSectionTitle}
        multiSection={true}
        renderSuggestionsContainer={this.renderSuggestionsContainer}
        shouldRenderSuggestions={this.shouldRenderSuggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        onSuggestionHighlighted={this.onSuggestionHighlighted}
        onSuggestionSelected={this.onSuggestionSelected}
        inputProps={inputProps}
      />
  
    );
  }
}

